import {
  ApiEntity
} from '@app/entities/api.entity';
import {
  environment
} from '@environment';

export const searchBarApi: ApiEntity = {
  default_place: {
    url: 'https://www.delta.com/pref/geoLocationService/getClosestDeltaAirportCode',
  },
  search: {
    // eslint-disable-next-line max-len
    url: `${environment.api.search}/api/travel/search/cities?query={term}&lang=${environment.language}&countrycode={code}&type={type}`,
  },
  travel_city_search: {
    // eslint-disable-next-line max-len
    url: `${environment.api.search}/api/travel-city-search/?query={term}&lang=${environment.language}&limit=${environment.travel_city_limit}&countrycode=${environment.countryInfo.iso_code}`,
  },
  find_code: {
    url: `${environment.api.search}/api/travel-city-search/find?countrycode={code}&lang=${environment.language}&type={type}`,
  },
  ip_public: {
    url: `${environment.api.ip}/?format=json`,
  },
  ubication_ip: {
    url: `${environment.api.search}/api/travel-city-search/near?ip={ip}&lang={lang}&maxdistance={distance}&type={type}`,
  },
  hotel_search_destination: {
    url: `${environment.api.static_search_hotel_autocomplete}/?query={searchText}&lang={locale}` + 
         `&limit=10&country=${environment.countryInfo.iso_code}`,
  },
  hotel_search_destination_by_info: {
    url: `${environment.api.travel_static_content}/hotel-location?id={id}&isHotel={isHotel}&locale={locale}`,
  },
  travel_extra_search: {
    // eslint-disable-next-line max-len
    url: `${environment.api.search}/api/travel-static-content-ms/travel-extra/activities/search?query={term}&lang=${environment.language}&limit=${environment.travel_city_limit}&countrycode=${environment.countryInfo.iso_code}`,
  },
  travel_extra_input_activity_info: {
    // eslint-disable-next-line max-len
    url: `${environment.api.search}/api/travel-static-content-ms/travel-extra/activities/{id}`,
  },
};
